<template>
    <rkm-overlay>
        <rkm-layout-body title="AIH">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'pronto-atendimento-aih-paciente' })"
                    color="primary"
                    authorize="store-pronto-atendimento-aih"
                >
                    Cadastrar internação
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List @click-to-edit="$router.push({ name: 'pronto-atendimento-aih-edit', params: { id: $event } })" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/pronto-atendimento/aih/List'

export default {
    components: { List }
}
</script>